export const APP_ADMIN_REALM_ROLE = 'APP_ADMIN'
